/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdWebFeaturesPlayGameUnityGameConfigOptions, FxIdWebFeaturesPlayGameUnityGameConfigOptionsFromJSONTyped, FxIdWebFeaturesPlayGameUnityGameConfigOptionsToJSON, } from './FxIdWebFeaturesPlayGameUnityGameConfigOptions';
export function FxIdWebFeaturesPlayGameResponseUnityGameConfigFromJSON(json) {
    return FxIdWebFeaturesPlayGameResponseUnityGameConfigFromJSONTyped(json, false);
}
export function FxIdWebFeaturesPlayGameResponseUnityGameConfigFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdWebFeaturesPlayGameUnityGameConfigOptions(json)) {
        return FxIdWebFeaturesPlayGameUnityGameConfigOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdWebFeaturesPlayGameResponseUnityGameConfigToJSON(json) {
    return FxIdWebFeaturesPlayGameResponseUnityGameConfigToJSONTyped(json, false);
}
export function FxIdWebFeaturesPlayGameResponseUnityGameConfigToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdWebFeaturesPlayGameUnityGameConfigOptions(value)) {
        return FxIdWebFeaturesPlayGameUnityGameConfigOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdWebFeaturesPlayGameResponseUnityGameConfig.js.map